module.exports = __webpack_public_path__ + "img/baner_zgody_750x200.533daa99.png";